import { render, staticRenderFns } from "./HomeworkReport.vue?vue&type=template&id=c3c3a672&scoped=true"
import script from "./HomeworkReport.vue?vue&type=script&lang=js"
export * from "./HomeworkReport.vue?vue&type=script&lang=js"
import style0 from "./HomeworkReport.vue?vue&type=style&index=0&id=c3c3a672&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c3a672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c3a672')) {
      api.createRecord('c3c3a672', component.options)
    } else {
      api.reload('c3c3a672', component.options)
    }
    module.hot.accept("./HomeworkReport.vue?vue&type=template&id=c3c3a672&scoped=true", function () {
      api.rerender('c3c3a672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/homework/HomeworkReport.vue"
export default component.exports